const URL_TESLA_VEHICLES = "https://com-surpnorm-senseev.appspot.com/v1/tesla/vehicles";

class TeslaVehiclesApi {

  static requestHeaders(deviceId, authToken) {
    return {'Authorization': `Bearer deviceId="${deviceId}",authenticationToken="${authToken}"`}
  }

  static getTeslaVehicles(deviceId, authToken) {
    const headers = this.requestHeaders(deviceId, authToken);
    const request = new Request(`${URL_TESLA_VEHICLES}`, {
      method: 'GET',
      headers: headers
    });

    return fetch(request).then(response => {
		if (response.status === 200) {
			return response.json().then(json => {
				return json.items;
			});
		} else if (response.status === 401) {
			console.log("Unauthenticated");
		}
		return [];
    }).catch(error => {
      return error;
    });
  }
}

export default TeslaVehiclesApi;


// WEBPACK FOOTER //
// ./src/api/teslaVehiclesApi.js